import { useEffect, useState } from 'react';
import api from '../../api/api';
import { Users, MapPin, DollarSign, BookOpen } from 'lucide-react';
import CountryHeatMap from './CountryHeatMap';
import AdminAnalytics from './AdminAnalytics';
import LiveViewers from './LiveViewers';
import AnalyticsCountry from './AnalyticsCountry';

export default function AdminDashboard() {
  const [stats, setStats] = useState({
    totalTours: 0,
    totalBookings: 0,
    totalUsers: 0,
    totalRevenue: 0,
    recentBookings: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [toursRes, bookingsRes, usersRes] = await Promise.all([
        api.get('/tours?limit=1000'),
        api.get('/bookings/admin/all'),
        api.get('/users'),
      ]);

      const tours = toursRes.data.tours || [];
      const bookings = bookingsRes.data || [];
      const users = usersRes.data || [];

      // Ensure total_price is a number
      const totalRevenue = bookings.reduce((sum, b) => sum + Number(b.total_price || 0), 0);

      setStats({
        totalTours: tours.length,
        totalBookings: bookings.length,
        totalUsers: users.length,
        totalRevenue,
        recentBookings: bookings.slice(0, 5),
      });
    } catch (err) {
      console.error('Error fetching stats:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-20 text-xl font-semibold text-gray-700 dark:text-gray-300">
        Loading dashboard...
      </div>
    );
  }

  return (
    <div className="">
      <h2 className="text-3xl font-bold mb-8 text-gray-900 dark:text-white">
        Dashboard Overview
      </h2>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {/* Total Tours */}
        <div className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-slate-700 flex items-center gap-4 hover:shadow-md transition">
          <div className="p-3 rounded-full bg-blue-100 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400">
            <MapPin size={28} />
          </div>
          <div>
            <p className="text-gray-500 dark:text-gray-400 text-sm">Total Tours</p>
            <h3 className="text-2xl font-bold text-gray-800 dark:text-white">{stats.totalTours}</h3>
          </div>
        </div>

        {/* Total Bookings */}
        <div className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-slate-700 flex items-center gap-4 hover:shadow-md transition">
          <div className="p-3 rounded-full bg-purple-100 dark:bg-purple-900/20 text-purple-600 dark:text-purple-400">
            <BookOpen size={28} />
          </div>
          <div>
            <p className="text-gray-500 dark:text-gray-400 text-sm">Total Bookings</p>
            <h3 className="text-2xl font-bold text-gray-800 dark:text-white">{stats.totalBookings}</h3>
          </div>
        </div>

        {/* Total Users */}
        <div className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-slate-700 flex items-center gap-4 hover:shadow-md transition">
          <div className="p-3 rounded-full bg-green-100 dark:bg-green-900/20 text-green-600 dark:text-green-400">
            <Users size={28} />
          </div>
          <div>
            <p className="text-gray-500 dark:text-gray-400 text-sm">Total Users</p>
            <h3 className="text-2xl font-bold text-gray-800 dark:text-white">{stats.totalUsers-1}</h3>
          </div>
        </div>

        {/* Total Revenue */}
        <div className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-slate-700 flex items-center gap-4 hover:shadow-md transition">
          <div className="p-3 rounded-full bg-yellow-100 dark:bg-yellow-900/20 text-yellow-600 dark:text-yellow-400">
            <DollarSign size={28} />
          </div>
          <div>
            <p className="text-gray-500 dark:text-gray-400 text-sm">Total Revenue</p>
            <h3 className="text-2xl font-bold text-gray-800 dark:text-white">
             {Number(stats.totalRevenue || 0).toFixed(2)}
            </h3>
          </div>
        </div>
      </div>
      <LiveViewers/>
<AdminAnalytics/>
      {/* Recent Bookings */}
   <AnalyticsCountry/>
    </div>
  );
}
